var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEvents = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 8 10",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.99994 0C2.21598 0 0.764648 1.45135 0.764648 3.23529C0.927296 7.52145 7.07324 7.52029 7.23524 3.23526C7.23524 1.45135 5.78389 0 3.99994 0ZM4.8823 2.35294H3.99994C3.61028 2.3678 3.61037 2.92639 3.99994 2.94118C4.99461 2.95994 5.215 4.31471 4.29406 4.65529V5.29412H3.70583V4.70588H3.11759V4.11765H3.99994C4.38961 4.10278 4.38951 3.5442 3.99994 3.52941C3.0053 3.51065 2.78488 2.15588 3.70583 1.81529V1.17647H4.29406V1.76471H4.8823V2.35294Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.5293 6.76453V7.64706H5.47047V6.76453C4.53251 7.15684 3.46851 7.15735 2.5293 6.76453Z",
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.41174 8.23529H4.58821V10H3.41174V8.23529Z",
  fill: "currentColor"
})));
export default SvgEvents;